var _circle, _path, _path2, _path3, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLfSuggestion = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: "dd-privacy-hidden"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.273 12v3.421a1 1 0 0 0 .54.888l4.727 2.452a1 1 0 0 0 .92 0l4.728-2.452a1 1 0 0 0 .54-.888V12l-5.152 2.672a1.25 1.25 0 0 1-1.152 0L6.273 12Z",
  fill: "#405B73"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m4.712 8.779 6.828-3.54a1 1 0 0 1 .92 0l6.828 3.54a1 1 0 0 1 0 1.775l-6.828 3.54a1 1 0 0 1-.92 0l-6.828-3.54a1 1 0 0 1 0-1.775Z",
  fill: "#405B73"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 10h7.5a.5.5 0 0 1 .5.5V14",
  stroke: "#F4CC54",
  strokeLinecap: "round"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 12,
  r: 1,
  fill: "#F4CC54"
})));
export default SvgLfSuggestion;